import { useMutation } from "@tanstack/react-query"
import axios, { AxiosError } from "axios"

import { FulfillmentResponse } from "types"

interface UseCompleteOrderMutationParams {
  onSuccess?: (orderId: string) => void
  onError?: (error: unknown) => void
  onCleanup?: () => void
}

interface CompleteOrderMutationParams {
  orderId: string
}

export const useCompleteOrderMutation = ({
  onSuccess,
  onError,
  onCleanup,
}: UseCompleteOrderMutationParams = {}) => {
  return useMutation({
    mutationFn: async ({ orderId }: CompleteOrderMutationParams) => {
      try {
        // Clean up local storage and context if provided
        if (onCleanup) {
          onCleanup()
        }

        const response = await axios.patch<FulfillmentResponse>(
          `/api/registration/order/${orderId}/complete-order/`
        )

        return { data: response.data, orderId }
      } catch (error) {
        const axiosError = error as AxiosError<{
          non_field_errors?: string[]
        }>

        // Handle specific case where order can no longer be updated
        // but we still want to treat it as a success for the UI
        if (
          axiosError.response?.data?.non_field_errors?.includes(
            "The order can no longer be updated"
          )
        ) {
          return { data: null, orderId }
        }

        throw error
      }
    },
    onSuccess: ({ orderId }) => {
      if (onSuccess) {
        onSuccess(orderId)
      }
    },
    onError,
  })
}